import * as React from 'react';

export const areChildrenEqual = (val1: React.ReactElement[], val2: React.ReactElement[]) => {
  const keys1 = val1.map(child => child.key);
  const keys2 = val2.map(child => child.key);

  // diferent size
  if (keys1.length !== keys2.length) {
    return false;
  }

  // check each key
  for (let i = 0; i < keys1.length; i++) {
    if (keys1[i] !== keys2[i]) {
      return false;
    }
  }

  return true;
};
